import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Hammer } from "lucide-react";
import { companyInfo, services } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1E2022] text-gray-300 border-t border-neutral-800">
      {/* Primær Footer Indhold */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Sektion 1: Om Virksomheden */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2 group">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/height=40,quality=95,format=auto/assets/531e2906-0b4f-4a2d-bfb4-6b0bf7bd2bc6/hellerup-logo-trans.png" 
                alt="Henneberg Byggeri Logo" 
                className="h-10 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <div className="flex gap-4 pt-2">
              <a
                href={companyInfo.socials.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 transition-colors hover:text-[#434359]"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={companyInfo.socials.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 transition-colors hover:text-[#434359]"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Sektion 2: Hurtige Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Hurtige Links
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="transition-colors hover:text-[#434359]">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="transition-colors hover:text-[#434359]">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="transition-colors hover:text-[#434359]">
                  Om Os
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="transition-colors hover:text-[#434359]">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Sektion 3: Vores Ydelser */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-4">
              Vores Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              {services.map((service) => (
                <li key={service.id}>
                  <Link to={`/ydelser/${service.id}`} className="transition-colors hover:text-[#434359]">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sektion 4: Kontakt */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Kontakt Os
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#434359] shrink-0 mt-0.5" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#434359] shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="transition-colors hover:text-[#434359] whitespace-nowrap">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#434359] shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="transition-colors hover:text-[#434359] whitespace-nowrap">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bund-bjælke */}
        <div className="mt-12 border-t border-neutral-800 pt-6 text-center text-xs text-gray-500 flex flex-col sm:flex-row sm:justify-between gap-4">
          <p>© {currentYear} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
          <p>CVR-nr: <span className="font-semibold text-gray-400">{companyInfo.cvr}</span></p>
        </div>
      </div>
    </footer>
  );
}
